import type { ImageSource } from "@/libs/image"
import { createAggregatedProgress } from "@/libs/progress"
import type { PerformanceEntry } from "@/libs/telemetry/performance"
import { Graph } from "../../framework"
import {
  type FaceDetection,
  type Options as FaceMeshOptions,
  create as createFaceMesh,
} from "../../modules/face-mesh/face-mesh"

export type { FaceDetection }

export type Options = {
  performance?: { child: () => PerformanceEntry }
  onProgress?: (progress: number) => void
} & Omit<FaceMeshOptions, "performance" | "onProgress">

export const create = async (opts?: Options) => {
  const onProgress = opts?.onProgress
    ? createAggregatedProgress({
        // 80% for module initialization
        // 20% for the rest
        coeffs: [0.8, 0.2],
        onProgress: opts.onProgress,
      })
    : undefined

  const graph = new Graph<[ImageSource], [FaceDetection]>()

  try {
    const faceMesh = await createFaceMesh(graph, {
      performance: opts?.performance?.child(),
      onProgress: onProgress?.bind(null, 0),
    })

    graph.in(0).connect(faceMesh.in(0))
    faceMesh.out(0).connect(graph.out(0))

    onProgress?.(1, 1)

    return graph
  } catch (e) {
    throw new Error("Failed to create FaceMesh node", { cause: e })
  }
}
